import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const languages = {
  AE: { label: 'UAE', flag: '/assets/flags/4x3/ae.svg' },
  CA: { label: 'Canada', flag: '/assets/flags/4x3/ca.svg' },
  IN: { label: 'India', flag: '/assets/flags/4x3/in.svg' }
};

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const [languageOpen, setLanguageOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState('AE');
  const languageRef = useRef(null);

  useEffect(() => {
    const updateScrollState = () => setScrolled(window.scrollY > 20);
    updateScrollState();
    window.addEventListener('scroll', updateScrollState, { passive: true });
    return () => window.removeEventListener('scroll', updateScrollState);
  }, []);

  useEffect(() => {
    const closeLanguageMenu = (event) => {
      if (!languageRef.current?.contains(event.target)) setLanguageOpen(false);
    };
    const closeWithEscape = (event) => {
      if (event.key === 'Escape') {
        setLanguageOpen(false);
        setNavOpen(false);
      }
    };
    document.addEventListener('click', closeLanguageMenu);
    document.addEventListener('keydown', closeWithEscape);
    return () => {
      document.removeEventListener('click', closeLanguageMenu);
      document.removeEventListener('keydown', closeWithEscape);
    };
  }, []);

  const selectLanguage = (code) => {
    setSelectedLanguage(code);
    setLanguageOpen(false);
  };

  return (
    <header className={`site-header ${scrolled ? 'is-scrolled' : ''}`}>
      <Link className="brand" to="/" aria-label="Elevate Realty home">
        <span className="brand-mark" aria-hidden="true" />
        <span className="brand-text">Elevate</span>
      </Link>

      <nav
        className={`main-nav ${navOpen ? 'is-open' : ''}`}
        aria-label="Primary navigation"
        onClick={() => setNavOpen(false)}
      >
        <Link to="/new-projects">Properties</Link>
        <Link to="/services">Services</Link>
        <Link to="/about">About</Link>
        <Link to="/contact-us">Contact</Link>
        <Link to="/social-feeds">Social Feeds</Link>
      </nav>

      <div className="header-actions">
        <div ref={languageRef} className={`language-select ${languageOpen ? 'is-open' : ''}`}>
          <button
            className="language-button"
            type="button"
            aria-label="Select country"
            aria-expanded={languageOpen}
            onClick={(event) => {
              event.stopPropagation();
              setLanguageOpen((open) => !open);
            }}
          >
            <img src={languages[selectedLanguage].flag} alt={languages[selectedLanguage].label} />
            <i className="fa-solid fa-chevron-down" />
          </button>

          <div className="language-menu">
            {Object.entries(languages).map(([code, language]) => (
              <button key={code} type="button" data-lang={code} onClick={() => selectLanguage(code)}>
                <img src={language.flag} alt="" />
                <span>{language.label}</span>
              </button>
            ))}
          </div>
        </div>

        <a href="tel:+971507135432" aria-label="Call Elevate Realty">
          <i className="fa-solid fa-phone" />
        </a>
        <a href="mailto:connect@elevaterealtyuae.com" aria-label="Email Elevate Realty">
          <i className="fa-regular fa-envelope" />
        </a>
        <a href="https://wa.me/971507135432" aria-label="Chat on WhatsApp">
          <i className="fa-brands fa-whatsapp" />
        </a>
      </div>

      <button
        className={`menu-toggle ${navOpen ? 'is-open' : ''}`}
        type="button"
        aria-label="Toggle menu"
        aria-expanded={navOpen}
        onClick={() => setNavOpen((open) => !open)}
      >
        <span />
        <span />
        <span />
      </button>
    </header>
  );
};

export default Header;
